(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["newsletter-reward"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('orky-newsletter-reward')) {
    customElements.define('orky-newsletter-reward', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const dialog = this.querySelector('dialog');
        const preview = this.querySelector('[data-reward-preview]');
        const open = () => {
          if (!dialog.open) dialog.showModal();
        };
        preview?.addEventListener('click', open);
        this.querySelector('[data-reward-close]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', (event) => {
          if (event.target !== dialog) return;
          const bounds = dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
        });
        dialog.addEventListener('close', () => {
          const target = preview || this.closest('.orky-footer__newsletter')?.querySelector('input[type="email"]');
          target?.focus({preventScroll: true});
        });
        const copy = this.querySelector('[data-reward-copy]');
        copy.addEventListener('click', async () => {
          const code = this.querySelector('[data-reward-code]');
          const status = this.querySelector('[data-copy-status]');
          try {
            await navigator.clipboard.writeText(code.value);
            status.textContent = copy.dataset.copiedLabel;
          } catch {
            code.focus();
            code.select();
            status.textContent = copy.dataset.fallbackLabel;
          }
        });
        if (this.hasAttribute('data-submitted')) open();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
